import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import Icons from '~/Common-Objects/UI/Icons/index'
import LoadingIcons from '~/Common-Objects/LoadingIcons/loadingIcon1'
import Select from '~/Common-Objects/UI/Forms/Select/Select'
import i18n from '~/i18n'
import axios from '~/data/http/axios'
import TwoColPaperExplainer from '../../../Components/TwoColPaperExplainer'

export default function Part1DomainServicePicker({
    domainId,
    setFlowStep,
    domainProvider = {},
    domainProviders = [],
    updateDomain = () => {},
    setDomainProvider = () => {}
}) {
    const site = useSelector((state) => state.siteMaster)
    const [selectedProvider, setSelectedProvider] = useState({})
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            saveProvider()
        }
    }

    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown)
        detectProvider()
        return () => {
            document.removeEventListener('keydown', handleKeyDown)
        }
    }, [])

    const detectProvider = async () => {
        const detectedProvider = await axios.get(`/accountMaster/domain/${domainId}/provider`)
        if (detectedProvider.data.provider) {
            detectedProvider.data.provider.auto = true
        }
        setSelectedProvider(detectedProvider.data.provider)
        setLoading(false)
    }

    const saveProvider = async () => {
        if (!selectedProvider.value) {
            setError('Please select a provider')
            return
        }
        setLoading(true)
        updateDomain({ serviceProvider: selectedProvider.value })
        setDomainProvider(selectedProvider)
        setFlowStep('dnsInstructions')
    }

    if (loading) {
        return (
            <>
                <LoadingIcons iconType='2' style={{ width: 32, height: 32, top: 0 }} />
            </>
        )
    }

    return (
        <>
            <h2 className='mar-b10 text-center'>{i18n.t('company:domains.domainManagement.tellUsHeader')}</h2>
            <div className='mar-b15 text-grey-800 text-sml' style={{ width: '100%', textAlign: 'center' }}>
                {i18n.t('company:domains.domainManagement.tellUsDesc1')}
            </div>
            <div className='mar-b40 text-grey-800 text-sml' style={{ width: '100%', textAlign: 'center' }}>
                {i18n.t('company:domains.domainManagement.tellUsDesc2')}
            </div>
            <div className='text-heavy mar-b5' style={{ width: '100%' }}>
                {i18n.t('company:domains.domainManagement.selectProvider')}
            </div>
            {selectedProvider &&
                selectedProvider.value &&
                selectedProvider.value != 'NONE' &&
                selectedProvider.auto && (
                    <div className='mar-b10'>
                        {i18n.t('company:domains.domainManagement.providerDetected')}{' '}
                        <strong>{selectedProvider?.label}</strong>.{' '}
                        {i18n.t('company:domains.domainManagement.providerIncorrect')}
                    </div>
                )}
            <Select
                error={error}
                outerstyle={{ width: '100%' }}
                inlineLabel=''
                value={selectedProvider?.value}
                placeholderNoSelect='Search Providers...'
                autoWidth={true}
                onChange={(e) => {
                    setError('')
                    const selProvider = domainProviders.find((provider) => provider.value == e.target.value)
                    setSelectedProvider(selProvider)
                }}
                iconLeftMarginRight={0}
                fixedHeightLarge={true}
                data={domainProviders?.map((provider, index) => {
                    return {
                        label: provider.label,
                        customLeft: provider.icon ? (
                            <Icons
                                icon={provider.icon}
                                style={{ width: '20px', height: '20px' }}
                                color={provider.iconColor}
                            />
                        ) : null,
                        customRight: provider.customRight ? provider.customRight : null,
                        value: provider.value,
                        noCheckBox: true
                    }
                })}
                filter={true}
                filterText='Search Providers'
            />
            {selectedProvider?.label && (
                <div className='mar-t40' style={{ width: '100%' }}>
                    <Button
                        text={i18n.t('company:domains.domainManagement.continue')}
                        iconRight={<Icons icon='arrowRight' />}
                        className='button-primary'
                        onClick={saveProvider}
                    />
                </div>
            )}
            <TwoColPaperExplainer
                className='mar-t40'
                title={i18n.t('company:domains.domainManagement.dnsExplainerTitle')}
                content={i18n.t('company:domains.domainManagement.dnsExplainerContent')}
            />
        </>
    )
}
